import { useEffect, useRef } from "react";

export function getPosition(opts = {}) {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) return reject(new Error("Location not supported on this device"));
    navigator.geolocation.getCurrentPosition(
      (p) => resolve({ lat: p.coords.latitude, lng: p.coords.longitude, accuracy: Math.round(p.coords.accuracy || 0) }),
      (e) => reject(e),
      { enableHighAccuracy: false, timeout: 9000, maximumAge: 60000, ...opts },
    );
  });
}

export function distanceM(a, b) {
  if (!a || !b) return Infinity;
  const r = 6371000, p1 = (a.lat * Math.PI) / 180, p2 = (b.lat * Math.PI) / 180;
  const x = Math.sin((p2 - p1) / 2) ** 2 + Math.cos(p1) * Math.cos(p2) * Math.sin(((b.lng - a.lng) * Math.PI) / 360) ** 2;
  return 2 * r * Math.asin(Math.sqrt(x));
}

// Battery-friendly: one fix every `intervalMin`, only sent if we moved > minMoveM (or first fix / every 3rd interval as heartbeat).
export function useLocationPings(active, intervalMin, minMoveM, onFix) {
  const last = useRef(null);
  const count = useRef(0);
  const cb = useRef(onFix);
  cb.current = onFix;
  useEffect(() => {
    if (!active) { last.current = null; count.current = 0; return; }
    let stopped = false;
    const run = async () => {
      try {
        const pos = await getPosition();
        if (stopped) return;
        count.current += 1;
        const moved = distanceM(last.current, pos);
        if (!last.current || moved >= (minMoveM || 75) || count.current % 3 === 0) { last.current = pos; cb.current?.(pos); }
      } catch { /* permission denied or unavailable — sharing simply pauses */ }
    };
    run();
    const t = setInterval(run, Math.max(1, intervalMin || 5) * 60000);
    return () => { stopped = true; clearInterval(t); };
  }, [active, intervalMin, minMoveM]);
}
